import { render, staticRenderFns } from "./ListApproved.vue?vue&type=template&id=5fcd1fe7&"
import script from "./ListApproved.vue?vue&type=script&lang=js&"
export * from "./ListApproved.vue?vue&type=script&lang=js&"
import style0 from "./ListApproved.vue?vue&type=style&index=0&id=5fcd1fe7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports